// frontend/src/components/Diario/ModalObservacaoLivre.jsx
// Modal completo para registro de observação livre

import React, { useState } from 'react';
import { toast } from 'react-toastify';
import { FileText, Save, X, ChevronDown } from 'lucide-react';
import Modal from '../UI/Modal';
import DropdownMenu from '../UI/DropdownMenu.jsx';

const TURNOS = ['Manhã', 'Tarde', 'Noite', 'Madrugada'];

/**
 * Modal completo para registro de observação livre
 */
const ModalObservacaoLivre = ({ isOpen, onClose, pacienteId, onCreateRegistro, onRegistroSucesso }) => {
    const [formData, setFormData] = useState({
        observacoes: '',
        turno: 'Manhã'
    });
    const [loading, setLoading] = useState(false);
    const [errors, setErrors] = useState({});

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
        
        if (errors[name]) {
            setErrors(prev => {
                const newErrors = { ...prev };
                delete newErrors[name];
                return newErrors;
            });
        }
    };

    const validateForm = () => {
        const newErrors = {};

        if (!formData.observacoes.trim()) {
            newErrors.observacoes = 'Observação é obrigatória';
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!validateForm()) {
            return;
        }

        setLoading(true);

        try {
            const dataToSend = {
                paciente_id: pacienteId,
                tipo_registro: 'Observacoes Gerais',
                observacoes: formData.observacoes,
                turno: formData.turno,
                detalhes: {}
            };

            await onCreateRegistro(dataToSend);
            toast.success('Observação registrada com sucesso!');
            
            if (onRegistroSucesso) {
                onRegistroSucesso();
            }
            
            // Resetar formulário
            setFormData({
                observacoes: '',
                turno: 'Manhã'
            });
            setErrors({});
            onClose();
        } catch (error) {
            toast.error(error.message || 'Erro ao registrar observação');
        } finally {
            setLoading(false);
        }
    };

    const handleClose = () => {
        if (!loading) {
            setFormData({
                observacoes: '',
                turno: 'Manhã'
            });
            setErrors({});
            onClose();
        }
    };

    return (
        <Modal isOpen={isOpen} onClose={handleClose} title="Registrar Observação Livre" size="lg">
            <form onSubmit={handleSubmit} className="space-y-6">
                {/* Observações */}
                <div>
                    <label htmlFor="observacoes" className="block text-sm font-medium text-gray-700 mb-2">
                        <FileText size={16} className="inline mr-2" />
                        Observação <span className="text-red-500">*</span>
                    </label>
                    <textarea
                        name="observacoes"
                        id="observacoes"
                        value={formData.observacoes}
                        onChange={handleChange}
                        placeholder="Descreva a observação ou intercorrência..."
                        rows="6"
                        required
                        className={`mt-1 block w-full border rounded-md shadow-sm p-3 text-sm focus:ring-emerald-500 focus:border-emerald-500 ${
                            errors.observacoes ? 'border-red-300' : 'border-gray-300'
                        }`}
                    />
                    {errors.observacoes && (
                        <p className="mt-1 text-xs text-red-600">{errors.observacoes}</p>
                    )}
                </div>

                {/* Turno */}
                <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                        Turno <span className="text-red-500">*</span>
                    </label>
                    <DropdownMenu
                        trigger={
                            <button
                                type="button"
                                className="mt-1 w-full flex items-center justify-between border border-gray-300 rounded-md shadow-sm p-3 text-sm focus:ring-emerald-500 focus:border-emerald-500 text-gray-900"
                            >
                                <span>{formData.turno}</span>
                                <ChevronDown size={18} className="text-gray-400" />
                            </button>
                        }
                        items={TURNOS.map(turno => ({
                            id: turno,
                            label: turno,
                            onClick: () => {
                                setFormData(prev => ({ ...prev, turno }));
                            }
                        }))}
                        position="bottom-left"
                        className="w-full"
                    />
                </div>

                {/* Botões */}
                <div className="flex justify-end gap-3 pt-4 border-t">
                    <button
                        type="button"
                        onClick={handleClose}
                        disabled={loading}
                        className="flex items-center gap-2 px-4 py-2 border border-gray-300 rounded-md text-sm font-medium text-gray-700 hover:bg-gray-50 transition disabled:opacity-50"
                    >
                        <X size={18} />
                        Cancelar
                    </button>
                    <button
                        type="submit"
                        disabled={loading}
                        className="flex items-center gap-2 px-4 py-2 bg-emerald-600 hover:bg-emerald-700 text-white font-semibold rounded-md transition disabled:opacity-50"
                    >
                        {loading ? (
                            <>Salvando...</>
                        ) : (
                            <>
                                <Save size={18} />
                                Registrar Observação
                            </>
                        )}
                    </button>
                </div>
            </form>
        </Modal>
    );
};

export default ModalObservacaoLivre;

